var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "external-link 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5085 13V19C18.5085 19.5304 18.2978 20.0391 17.9228 20.4142C17.5477 20.7893 17.039 21 16.5085 21H5.50854C4.97811 21 4.4694 20.7893 4.09433 20.4142C3.71926 20.0391 3.50854 19.5304 3.50854 19V8C3.50854 7.46957 3.71926 6.96086 4.09433 6.58579C4.4694 6.21071 4.97811 6 5.50854 6H11.5085",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5085 3H21.5085V9",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5085 14L21.5085 3",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink2);
export default __webpack_public_path__ + "static/media/external-link2.b08386135579877f80e741b6bf428384.svg";
export { ForwardRef as ReactComponent };